<template>
  <div>
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div v-if="isLoading" class="text-center">
            <hr class="space space-sm">
            <loader size="128px"></loader>
            <p class="small muted pt-4">Just a moment...</p>
          </div>
          <div v-else-if="submitted" class="text-center">
            <hr class="space space-sm">
            <h1 class="title">Thank you.</h1>
            <p>
              <img src="/static/images/check.svg" class="m-4" width="96px" />
            </p>
            <p>
              We have received your request and we will be in touch very shortly.
            </p>
            <img height="1" width="1" style="display:none;" alt="" src="https://px.ads.linkedin.com/collect/?pid=2882252&conversionId=3435092&fmt=gif" />
            <hr class="space space-sm">
            <router-link :to="{ name: 'home' }" class="btn btn-outline-primary">Return to homepage</router-link>
          </div>
          <div v-else>
            <hr class="space space-sm">
            <h1 class="h1-lg text-center">Start a Project with Us</h1>
            <hr class="space space-sm">
            <p class="small">
              If you have a new project or an existing one and would like to get some help with it,
              please let us know some details using the form below and we'll get back to you the following day.
            </p>
            <p>
              Or, if you prefer, you can <router-link :to="{ name: 'contact' }" class="medium">talk to us</router-link> first.
            </p>
            <br>

            <b-form @submit.prevent="submit">
              <b-form-group label="Your name:">
                <b-form-input id="name"
                              type="text"
                              v-model="form.name"
                              required>
                </b-form-input>
              </b-form-group>
              <b-form-group label="Email:">
                <b-form-input id="email"
                              type="email"
                              v-model="form.email"
                              required>
                </b-form-input>
              </b-form-group>
              <b-form-group label="Phone number:" description="Optional. Please include country code.">
                <b-form-input id="phone"
                              type="text"
                              v-model="form.phone">
                </b-form-input>
              </b-form-group>
              <b-form-group
                label="About the project:"
                description="Please let us know what the project is, what stage it is at and anything else that you feel relevant.">
                <b-form-textarea id="about"
                                v-model="form.about"
                                :rows="5"
                                :max-rows="10">
                </b-form-textarea>
              </b-form-group>
              <div class="error" v-if="hasError">
                {{ this.errorInfo }}
              </div>
              <div class="text-center">
                <br>
                <b-button type="submit" variant="primary">Send Message</b-button>
              </div>
              <p class="small mt-4 text-center">
                We usually respond within a day.
              </p>
            </b-form>
            <hr class="space">
            <div class="text-center py-4">
              <p>
                Too soon?<br/>
                Not sure where to start?<br/>
                Have a question?
              </p>
              <a href="#" class="btn btn-outline-primary" @click.prevent="openChat()">
                  Chat to us now
              </a>
              <hr class="space">
            </div>
          </div>
        </div>
      </div>
    </div>
    <hr class="divider">
  </div>
</template>

<script>
export default {
  name: 'login',
  data () {
    return {
      form: {
        name: null,
        email: null,
        phone: null,
        about: null,
        budget: null
      },
      isLoading: false,
      submitted: false,
      hasError: false,
      errorInfo: null
    }
  },
  methods: {
    submit () {
      this.hasError = false
      this.isLoading = true
      const { form } = this
      this.$store.dispatch('REQUEST_PROPOSAL', form).then((response) => {
        window.scrollTo(0, 0)
        this.isLoading = false
        this.submitted = true
        this.$ga.event('Proposal', 'request')
      }, error => {
        this.isLoading = false
        console.log('error', error)
        this.hasError = true
        this.errorInfo = 'Something didn\'t work. Please try again.'
        if (error.response && error.response.data) {
          this.errorsInfo = error.response.data
        }
      })
    },
    openChat () {
      window.customerly.open()
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  computed: {
  },
  created () {
  }
}
</script>

<style lang="scss">
</style>
